export const formatFufiTitle = (title: string) => {
	return title
		.split("")
		.filter((char) => char != "/")
		.join("")
		.trimEnd();
};
